import * as yup from 'yup'

export const verifySchema = yup.object({
	email: yup.string().email().required('O email é obrigatório'),
})